export var Shift;
(function (Shift) {
    Shift["AM"] = "AM";
    Shift["PM"] = "PM";
})(Shift || (Shift = {}));
